export var UNPLANNED_TASKS_DROPPABLE_ID = 'unplanned-tasks';
export var UNPLANNED_DRAG_PREFIX = 'unplanned:';
export var defaultUnplannedTasksFilters = {
    userIsNextAssignedUser: true,
    mainSelected: true,
    subSelected: true,
    taskTemplates: [],
    subtaskTemplate: undefined,
    deadlineFrom: undefined,
    deadlineUntil: undefined,
    relationId: undefined,
    requiresDuration: false,
};
export var countActiveUnplannedTasksFilters = function (filters) {
    var count = 0;
    if (filters.userIsNextAssignedUser === false)
        count += 1;
    if (filters.requiresDuration === true)
        count += 1;
    // Count "task level" as active when not both selected (i.e. user has narrowed/cleared the filter).
    var mainSelected = filters.mainSelected !== false;
    var subSelected = filters.subSelected !== false;
    if (!mainSelected || !subSelected)
        count += 1;
    if (filters.taskTemplates && filters.taskTemplates.length > 0)
        count += 1;
    if (filters.subtaskTemplate)
        count += 1;
    if (filters.deadlineFrom)
        count += 1;
    if (filters.deadlineUntil)
        count += 1;
    if (filters.relationId)
        count += 1;
    return count;
};
